/**
 * RESPONSIBILITY: the Children's page opening band.
 */
import type { ChildrenHeroSection } from '@app/sections';
import { Picture } from '../commons/Picture';

export function ChildrenHero({ c }: { c: ChildrenHeroSection }) {
  return (
    <section className="band">
      <div className="wrap split">
        <div className="framed"><h1>{c.heroTitle}</h1></div>
        <Picture value={c.heroImage} alt="" className="block-pic" />
      </div>
    </section>
  );
}
